import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'Is my regret really permanent?',
    answer: 'Yes. Once your payment is confirmed, your regret is stored permanently in our database and displayed on the wall forever. There is no way to edit or delete it — not by you, not by us. This is by design. Regrets are permanent in life, and they\'re permanent here.',
  },
  {
    question: 'Is it truly anonymous?',
    answer: 'Completely. We don\'t collect your name, email, or any personal information. We don\'t create accounts. The only thing stored alongside your regret is a payment confirmation ID from Stripe — nothing that identifies you personally. We can\'t trace a regret back to you, and neither can anyone else.',
  },
  {
    question: 'Why $1?',
    answer: 'The small fee serves two purposes: it keeps spam and low-effort posts out, and it makes people think twice before posting. A dollar is low enough that anyone can participate, but high enough to ensure every regret is genuine. It\'s the cost of a moment of reflection.',
  },
  {
    question: 'Can I delete my regret later?',
    answer: 'No. There is no delete button, no "contact support" option, no appeals process. Once posted, your regret lives on the wall forever. We strongly encourage you to read what you\'ve written carefully before paying. This is permanent.',
  },
  {
    question: 'What happens to offensive content?',
    answer: 'We have automated filters that block spam, URLs, email addresses, and obviously harmful content before it\'s posted. Extremely offensive content may be hidden from public view, but it\'s never deleted from our database. The wall is curated for readability, not censored for comfort.',
  },
  {
    question: 'How are categories assigned?',
    answer: 'Categories (Love, Career, Family, Money, Health, Other) are automatically detected based on keywords in your text. You\'ll see the suggested category before you pay. It helps people browse the wall, but doesn\'t change your regret.',
  },
  {
    question: 'Can I post multiple regrets?',
    answer: 'Yes. Each regret costs $1. There\'s no limit to how many you can share, but remember — each one is permanent.',
  },
  {
    question: 'What\'s the character limit?',
    answer: '180 characters. Short enough to be a single thought, long enough to carry weight. No essays, no explanations — just the regret itself.',
  },
  {
    question: 'Who built this?',
    answer: 'Wall of Regrets is an independent project. We believe there\'s value in anonymous confession — in saying the things you can\'t say anywhere else, to no one in particular, forever.',
  },
  {
    question: 'What if the site shuts down?',
    answer: 'We intend to keep the wall online indefinitely. Should circumstances change, we\'d archive the database publicly before shutting down. The regrets would live on.',
  },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-serif font-semibold text-gray-900 mb-4">
          Frequently Asked Questions
        </h1>
        <p className="text-lg text-gray-600">
          Everything you need to know before posting your regret.
        </p>
      </div>

      {/* Permanence warning */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-12">
        <div className="flex items-start gap-4">
          <div className="text-amber-600 text-2xl">⚠️</div>
          <div>
            <h2 className="font-semibold text-amber-900 text-lg mb-2">
              The Wall is Permanent
            </h2>
            <p className="text-amber-800">
              Every regret posted here stays forever. There is no undo, no edit, no delete.
              Read your words carefully before you pay. Once it's on the wall, it's there for good.
            </p>
          </div>
        </div>
      </div>

      {/* FAQ items */}
      <div className="space-y-8">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-parchment-300 pb-8 last:border-0">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {faq.question}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {faq.answer}
            </p>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="mt-16 text-center">
        <p className="text-gray-600 mb-6">
          Ready to let go of something?
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/submit" className="btn btn-primary">
            Share your regret — $1
          </Link>
          <Link to="/" className="btn btn-secondary">
            Read the wall
          </Link>
        </div>
      </div>
    </div>
  );
}
